if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productInfo = this.productSection.querySelector('.product-info');
      this.productForm = this.productSection.querySelector('product-form');

      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }

      this.bindScrollToAddToCart();
      this.bindVariantTitleUpdate();
    }

    // Start # sticky-atc-scroll-fix
    bindScrollToAddToCart() {
      const scrollBtn = this.querySelector('[data-sticky-atc-scroll]');
      if (!scrollBtn) return;

      scrollBtn.addEventListener('click', () => {
        const targetSelector = scrollBtn.getAttribute('data-scroll-target');
        const target = targetSelector ? document.querySelector(targetSelector) : null;

        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }
    // End # sticky-atc-scroll-fix

    // Start # sticky-atc-variant-title
    bindVariantTitleUpdate() {
      const variantTitleEl = this.querySelector('[data-sticky-atc-variant-title]');
      if (!variantTitleEl) return;

      document.addEventListener('on:variant:change', (event) => {
        const variant = event.detail && event.detail.variant;
        if (variant && variant.title) {
          variantTitleEl.textContent = variant.title;
        }
      });
    }
    // End # sticky-atc-variant-title

    // eslint-disable-next-line class-methods-use-this
    disconnectedCallback() {
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    bindEvents() {
      // Start # sticky-atc-reveal-fix: was gated on the whole .product-info
      // column fully leaving the viewport on desktop (title + options +
      // description + specs — often 1800px+ tall), so the bar only appeared
      // long after the real Add to Cart button was already out of view. Now
      // both mobile and desktop key off the real button itself, like mobile
      // always did.
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === this.productForm) {
            this.classList.toggle('sticky-atc-panel--out', entry.boundingClientRect.bottom > 0);
          }
        });
      });

      if (this.productForm) observer.observe(this.productForm);
      // End # sticky-atc-reveal-fix

      // Start # sticky-atc-bottom-check-fix: document.body.scrollHeight is
      // unreliable right after load, before async content (e.g. Judge.me's
      // full review list, ~2200px on some products) has finished injecting.
      // Scrolling past the real Add to Cart button on that still-short page
      // can incorrectly read as "near the bottom", hiding the panel until
      // that content finally loads and grows the page. Hold off trusting
      // the bottom check until the page's mutations go quiet for a moment
      // (content has settled) or 2s pass, whichever is first — and keep
      // re-checking on any later mutations too, in case more content loads
      // in after that.
      let bottomCheckReady = false;
      let settleTimer;

      function markReady() {
        bottomCheckReady = true;
        StickyAtcPanel.handleScroll();
      }

      settleTimer = setTimeout(markReady, 2000);

      const settleObserver = new MutationObserver(function () {
        if (bottomCheckReady) {
          StickyAtcPanel.handleScroll();
        } else {
          clearTimeout(settleTimer);
          settleTimer = setTimeout(markReady, 300);
        }
      });
      settleObserver.observe(document.body, { childList: true, subtree: true });

      window.addEventListener('scroll', function () {
        if (bottomCheckReady) StickyAtcPanel.handleScroll();
      });
      // End # sticky-atc-bottom-check-fix
    }

    /**
     * Watches for a scroll to the bottom of the page
     */
    static handleScroll() {
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}